export const accountElseWhereText = {
    title: {
        en: "Account Used Elsewhere",
        mr: "इतरत्र वापरलेले खाते",
    },
    message: {
        en: "Your account was used on another device. Log in again to continue.",
        mr: "तुमचे खाते दुसऱ्या डिव्हाइसवर वापरले गेले होते. पुढे जाण्यासाठी पुन्हा लॉग इन करा.",
    },
    tryAgain: {
        en: "Try Again",
        mr: "पुन्हा प्रयत्न करा",
    },
};
